import React, { Component } from 'react';
import SafeManagementSave from './SafeManagementSave';
import WithRouter from 'custom/withRouter';
import SafeManageMentList from './SafeManageMentList';

class SafeManagementPage extends Component {
  constructor(props, context) {
    super(props, context);
  }

  callListView = () => {
    this.props.navigate("/admin/safemanagement");
  }

  callSaveView = () => {
    this.props.navigate("/admin/safemanagement/add");
  }

  render() {
    const p = this.props;

    const isEditing = p.location.pathname === "/admin/safemanagement/add" ? true : false;

    return (
      <div>
        {
          isEditing ?
            <SafeManagementSave params={p.params} callListView={this.callListView} title="Add New Safe Mangement" />
            : <SafeManageMentList callSaveView={this.callSaveView} title="List of Safe Managements" />
        }
      </div>
    );
  }
}

export default WithRouter(SafeManagementPage);

